module.exports = __webpack_public_path__ + "img/cacao-2.bb2d663a.png";